import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[telefoneCelularMask]'
})
export class TelefoneCelularMaskDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';

    value = value.replace(/\D/g, '');

    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    if (value.length > 2) {
      value = value.replace(/^(\d{2})(\d)/, '($1) $2');
    }

    if (value.length > 7) {
      value = value.replace(/(\d{5})(\d)/, '$1-$2');
    }

    this.ngControl.control.setValue(value, { emitEvent: false });
  }
}
